var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOrangeAccountNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7812 10.5H10.2188C9.27065 10.5 8.5 11.322 8.5 12.3334V20.6666C8.5 21.678 9.27065 22.5 10.2188 22.5H21.7812C22.7293 22.5 23.5 21.678 23.5 20.6666V12.3334C23.5 11.322 22.7293 10.5 21.7812 10.5ZM13.1875 13.1666C14.0488 13.1666 14.75 13.9147 14.75 14.8334C14.75 15.7519 14.0488 16.5 13.1875 16.5C12.3262 16.5 11.625 15.7519 11.625 14.8334C11.625 13.9147 12.3262 13.1666 13.1875 13.1666ZM16 19.3334C16 19.6094 15.79 19.8334 15.5312 19.8334H10.8438C10.585 19.8334 10.375 19.6094 10.375 19.3334V19C10.375 17.9887 11.1457 17.1666 12.0938 17.1666H14.2812C15.2293 17.1666 16 17.9887 16 19V19.3334ZM21.1562 19.8334H17.7188C17.46 19.8334 17.25 19.6094 17.25 19.3334C17.25 19.0574 17.46 18.8334 17.7188 18.8334H21.1562C21.415 18.8334 21.625 19.0574 21.625 19.3334C21.625 19.6094 21.415 19.8334 21.1562 19.8334ZM21.1562 17.1666H17.7188C17.46 17.1666 17.25 16.9426 17.25 16.6666C17.25 16.3906 17.46 16.1666 17.7188 16.1666H21.1562C21.415 16.1666 21.625 16.3906 21.625 16.6666C21.625 16.9426 21.415 17.1666 21.1562 17.1666ZM21.1562 14.5H17.7188C17.46 14.5 17.25 14.276 17.25 14C17.25 13.724 17.46 13.5 17.7188 13.5H21.1562C21.415 13.5 21.625 13.724 21.625 14C21.625 14.276 21.415 14.5 21.1562 14.5Z",
    fill: "#E1591F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrangeAccountNumber);
export default __webpack_public_path__ + "static/media/icon-orange-account-number.849456f85b0678f6b75dc12213aab0cb.svg";
export { ForwardRef as ReactComponent };